.userMenuDesktop {
  position: absolute;
  top: 0;
  right: 0;
  width: 270px;
  background-color: rgba(21, 45, 88, 0.6);
  border-radius: 10px;
  padding: 1rem;
  text-align: justify;

  >div:first-child {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(203, 213, 225, 0.2);
    padding-bottom: 0.6rem;

    >div:nth-child(2) {
      display: flex;
      flex-direction: column;
      margin-left: 0.6rem;

      >span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 11.5rem;
      }

      >span:first-child {
        margin-bottom: -0.37rem;
        font-size: 0.9rem;
      }

      >span:nth-child(2) {
        font-size: 0.75rem;
        color: #CBD5E1;
      }
    }
  }
}

.userMenuList {
  list-style: none;
  margin-top: 0.3rem;
  padding-inline-start: 0.7em;
  font-size: 0.9rem;

  >li {
    margin-bottom: 0.2rem;
    cursor: pointer;
    transition: color 0.3s ease;
    width: fit-content;
    padding: 0.3rem 0.5rem;
    border-radius: 5px;

    &:hover {
      color: #CBD5E1;
      background-color: rgba(255, 255, 255, 0.1);
      cursor: pointer;
    }
  }

  >li:last-child {
    color: #F87171;
  }
}

.userIcon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-icon lucide-user"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.mobileViewIcon {
  width: 34px;
  height: 34px;
}

.threeDotIcon {
  width: 24px;
  height: 24px;
  display: inline-block;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4 6H20" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 12H20" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 18H20" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 20px;
  left: 0;
}

.userAvatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background-color: #006FCF;
  display: grid;
  place-items: center;
}

.userMenuMobileHeading {
  display: flex;
  align-items: center;
  gap: 1rem;

  .userAvatar {
    width: 50px;
    height: 50px;
  }

  >div:nth-child(2) {
    display: flex;
    flex-direction: column;

    >span {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      max-width: 15.5rem;
    }

    >span:first-child {
      margin-bottom: -0.35rem;
    }

    >span:nth-child(2) {
      font-size: 0.9rem;
      color: #CBD5E1;
    }
  }
}

.userMenuMobileList {
  font-size: 1rem;
}